const CACHE_PREFIX = "hris_cache_";

export const setCache = (key, data, ttl = 30000) => {
  const payload = {
    data,
    expiry: Date.now() + ttl,
  };

  localStorage.setItem(
    CACHE_PREFIX + key,
    JSON.stringify(payload)
  );
};

export const getCache = (key) => {
  const raw = localStorage.getItem(CACHE_PREFIX + key);

  if (!raw) return null;

  try {
    const payload = JSON.parse(raw);

    if (Date.now() > payload.expiry) {
      localStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }

    return payload.data;

  } catch {
    return null;
  }
};

export const clearCache = (key) => {
  if (!key) {
    Object.keys(localStorage)
      .filter((storageKey) => storageKey.startsWith(CACHE_PREFIX))
      .forEach((storageKey) => localStorage.removeItem(storageKey));
    return;
  }

  const exactKey = CACHE_PREFIX + key;
  const scopedKey = `${exactKey}_`;

  Object.keys(localStorage)
    .filter((storageKey) => storageKey === exactKey || storageKey.startsWith(scopedKey))
    .forEach((storageKey) => localStorage.removeItem(storageKey));
};
